import NoteAddIcon from '@mui/icons-material/NoteAdd';
import {
  Box,
  Button,
  Divider,
  Grid,
  Paper,
  Tooltip,
  Typography,
} from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import DownloadableAttachment from '../utils/common/DownloadableAttachment';
import TypographyWithHighlightMentions from '../utils/common/TypographyWithHighlightMentions.jsx';
import AddNoteDialog from './AddNoteDialog.jsx';

export const Note = (props) => {
  const { note, ticket, setContentToDisplay, _mutate, _mutateTicket } = props;
  const navigate = useNavigate();

  const handleNavigateToTicket = (_e) => {
    const contentToDisplay = 'tickets';
    setContentToDisplay(contentToDisplay);
    const ticketId = note?.ticket?._id;
    const _taskId = note?.task?._id;
    const projectId = note?.project?._id;

    navigate(`/project/${projectId}/${contentToDisplay}/${ticketId}/tasks`);
  };
  const handleNavigateNewNote = (_e) => {
    const contentToDisplay = 'tickets';
    setContentToDisplay(contentToDisplay);
    const ticketId = note?.ticket?._id;
    const taskId = note?.task?._id;
    const projectId = note?.project?._id;

    navigate(
      `/project/${projectId}/${contentToDisplay}/${ticketId}/tasks/${taskId}`
    );
  };

  return (
    <Paper elevation={10} key={note?._id} sx={{ padding: 1, marginBottom: 1 }}>
      <Grid container sx={{ whiteSpace: 'nowrap' }}>
        <Grid size="grow">
          <Typography
            component={'span'}
            sx={{ fontWeight: 'bold' }}
          >{`${note?.user?.firstName} ${note?.user?.lastName}`}</Typography>
        </Grid>
        <Grid size="grow">
          {!ticket ? (
            <Typography component={'span'} sx={{ fontWeight: 'bold' }}>
              {note?.task?._id
                ? 'Tâches'
                : note?.ticket?._id
                  ? 'Ticket'
                  : 'Projet'}
            </Typography>
          ) : null}
        </Grid>
        <Grid size="grow">
          <Typography component={'span'} sx={{ fontWeight: 'bold' }}>
            {note?.type?.name}
            {note?.task?._id ? ` (${note?.task?.action?.name})` : ''}
          </Typography>
        </Grid>
        <Grid size="grow">
          {!ticket ? (
            <div>
              <Tooltip
                placement="bottom"
                align="center"
                title={'Cliquez pour ouvrir le ticket correspondant'}
              >
                <Typography
                  component={'span'}
                  onClick={handleNavigateToTicket}
                  sx={{
                    fontWeight: 'bold',
                    cursor: 'pointer',
                    color: '#10407B',
                  }}
                >
                  {note?.ticket?.reference}
                </Typography>
              </Tooltip>

              {note?.task?._id && (
                <Button
                  variant="contained"
                  size="small"
                  onClick={handleNavigateNewNote}
                  sx={{
                    textTransform: 'none',
                    backgroundColor: '#D4A713',
                    ':hover': {
                      backgroundColor: '#b48c0b',
                    },
                    padding: '0.15em 0.5em',
                    marginLeft: '10em',
                    marginBottom: '0.5em',
                  }}
                  startIcon={<NoteAddIcon />}
                >
                  Ajouter une note
                </Button>
              )}
            </div>
          ) : null}
        </Grid>
        <Grid sx={{ textAlign: 'right' }} size="grow">
          <Typography
            component={'span'}
            variant="caption"
            sx={{ fontWeight: 'bold', fontSize: '0.8em' }}
          >
            {new Date(note?.date).toLocaleString('fr-FR', {
              year: 'numeric',
              month: 'long',
              day: 'numeric',
              hour: 'numeric',
              minute: 'numeric',
            })}
          </Typography>
        </Grid>
      </Grid>
      <Divider />
      <Box>
        <TypographyWithHighlightMentions text={note?.content} />
      </Box>
      {note?.attachments?.length > 0 ? (
        <>
          <Divider />
          {note?.attachments?.map((attachment) => {
            return (
              <DownloadableAttachment
                key={attachment?._id}
                attachment={attachment}
              />
            );
          })}
        </>
      ) : null}
    </Paper>
  );
};

const Notes = (props) => {
  const {
    notes,
    project,
    ticket,
    mutate,
    mutateTicket,
    displayAddNoteDialog,
    handleDisplayAddNoteDialog,
    setContentToDisplay,
  } = props;

  return (
    <>
      <AddNoteDialog
        open={displayAddNoteDialog}
        handleCloseDialog={handleDisplayAddNoteDialog}
        project={project}
        ticket={ticket}
        defaultType="USERNOTE"
        mutate={mutateTicket}
      />
      <Box
        sx={{
          maxHeight: !ticket ? '90vh' : '70vh',
          overflow: 'auto',
          paddingTop: 1,
          paddingLeft: 1,
          paddingRight: 0.5,
        }}
      >
        {notes
          ?.filter((note) => note.isValidated)
          .map((note, idx) => {
            return (
              <Note
                key={idx}
                note={note}
                ticket={ticket}
                setContentToDisplay={setContentToDisplay}
                mutate={mutate}
                mutateTicket={mutateTicket}
              />
            );
          })}
      </Box>
    </>
  );
};

export default Notes;
